import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const DomainContext = createContext(null);

export function DomainProvider({ children }) {
  const { user } = useAuth();
  const [domains, setDomains] = useState([]);
  const [selectedId, setSelectedId] = useState(() => localStorage.getItem("selectedDomain") || "");
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/domains");
      setDomains(data);
      setSelectedId((prev) => {
        if (prev && data.some((d) => d.id === prev)) return prev;
        return data[0]?.id || "";
      });
    } catch {
      setDomains([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (user) refresh();
  }, [user, refresh]);

  const select = useCallback((id) => {
    setSelectedId(id);
    localStorage.setItem("selectedDomain", id);
  }, []);

  const selected = domains.find((d) => d.id === selectedId) || null;

  return (
    <DomainContext.Provider value={{ domains, selected, selectedId, select, refresh, loading }}>
      {children}
    </DomainContext.Provider>
  );
}

export const useDomains = () => useContext(DomainContext);
